import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/agent-hero.jpeg")